import script from "./TableActions.vue?vue&type=script&setup=true&lang=js"
export * from "./TableActions.vue?vue&type=script&setup=true&lang=js"

import "./TableActions.vue?vue&type=style&index=0&id=35eaa4aa&lang=scss&scoped=true"
script.__scopeId = "data-v-35eaa4aa"

export default script